"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getPluginsConf;

function getPluginsConf(rest, plugins) {
  var pluginsConf = {};
  plugins.forEach(function (plugin) {
    var id = plugin.id;

    if (rest[id]) {
      pluginsConf[id] = rest[id];
    }
  });
  return pluginsConf;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/Chart/helpers/getPluginsConf.js
// module id = wucl
// module chunks = 0